module.exports = "/assets/data/23f709f05ee362b8ebd4426bbdbbd30f-EC1R.data.json";